import React from 'react';
import { motion } from 'framer-motion';
import "../Main.css";

const variants = {
    visible: {opacity: 1, y: 0},
    hidden: {opacity: 0, y: 30}
}

function ParaContent(props){
    return(
        <div className='content quicksand'>
            <motion.p variants={variants} initial="hidden" whileInView="visible" transition={{duration: 0.4}} viewport={{once: true, amount: 0.5}}>{props.content}</motion.p>
        </div>
    );
}

export default ParaContent;